import type { TPageHead } from '@/utils/seo.js';

// Writes a page's title, description and address to the head. The worker writes the same ones into
// the HTML of a page load (worker/page.ts); this keeps them in step when the app changes dataset,
// for the tab's title and for search engines that run the app.
export const setPageHead = ({ title, description, url, image }: TPageHead) => {
	document.title = title;
	const set = (selector: string, attribute: string, value: string) =>
		document.head.querySelector(selector)?.setAttribute(attribute, value);

	set('meta[name="description"]', 'content', description);
	set('link[rel="canonical"]', 'href', url);
	set('meta[property="og:title"]', 'content', title);
	set('meta[property="og:description"]', 'content', description);
	set('meta[property="og:url"]', 'content', url);
	if (image) set('meta[property="og:image"]', 'content', image);
};
